/* 
  prodArr : An array returned by the add.js call. 
*/
window.twitterEvent = function(prodArr){
  var currentDateTime = new Date();
  var currTimeStamp = parseInt(currentDateTime.getTime() / 1000);
  
  // initiate twitter Add To Cart Event
  twq('event', 'tw-pixel_id1-event_id1', {
    value: (prodArr.final_price / 100),
    currency: 'USD',
    conversion_id: currTimeStamp,
    contents: 
    [
       {content_id: prodArr.variant_id, content_name: prodArr.title, content_price: (prodArr.price / 100), num_items: prodArr.quantity}
    ]
  });
}

window.twtrInitiateCheckout = function(){
  jQuery.getJSON('/cart.js', function(cart) {
    
    // initiate twitter begin chckout
    twq('event', 'tw-oe95n-oe95r', {
      value: (cart.total_price/100),
      currency: "USD"
    });
  } );
}

const checkButtonExists = setInterval(() => {
  if(document.querySelector(".checkout_btn_twtr_evnt") != null){
    if(!document.querySelector(".checkout_btn_twtr_evnt").classList.contains("event-added")) {
     document.querySelector(".checkout_btn_twtr_evnt").classList.add("event-added");
      document.querySelector(".checkout_btn_twtr_evnt").addEventListener("click", function(e){
        e.preventDefault();
        window.twtrInitiateCheckout();
        var urlRedirection = "/checkout";
        setTimeout(function(){
          window.location.href = urlRedirection;
        }, 500);
      }, true);
    } 
  }
}, 100);


if(document.getElementById('bundleupsellproduct')){
  const bundleUpsellCheckbox = document.getElementById('bundleupsellproduct');
  bundleUpsellCheckbox.addEventListener('change', function(ele) {
    if (bundleUpsellCheckbox.checked) {
      document.querySelector('.product-form').querySelector('form input[name="id"]').value = parseInt(ele.target.dataset.id);
    } else {
      document.querySelector('.product-form').querySelector('form input[name="id"]').value = parseInt(document.querySelector('.bundleDefaultId').value);
    }
  });  
}

$('.accordion__item').click(function() {
  if (!$(this).hasClass('active')) {
    $('.accordion__item').removeClass('active');
    $('.accordion__item-content').slideUp();
    
    $(this).addClass('active');
    $(this).find('.accordion__item-content').slideDown();
  } else {
    $('.accordion__item').removeClass('active');
    $('.accordion__item-content').slideUp();
  }
});


var video = document.getElementById("half__banner_video");
if (video) {
  video.play(); 
} else {
  console.log("Video element not found.");
}

function adjustElementHeight() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', adjustElementHeight);

// Initial adjustment on page load
adjustElementHeight();

// glossary page serach functionality
document.addEventListener("DOMContentLoaded", function () {
    let glossarySearchForms = document.querySelectorAll(".glossary__search--wrap .header__search-form");
    glossarySearchForms.forEach(function (glossarySearchForm) {
       glossarySearchForm.addEventListener("submit", function (e) {
         e.preventDefault();
         return false;
       });
    });
  
    let glossarySearchInputs = document.querySelectorAll(".glossary__search--wrap .header__search-input");
      glossarySearchInputs.forEach(function (glossarySearchInput) {
        glossarySearchInput.addEventListener("input", function () {
            let searchValue = glossarySearchInput.value.trim();
            let glossaryItems = document.querySelectorAll(".glossary__item");
            let matchFound = false;
            glossaryItems.forEach(function (glossaryItem) {
                let blockLetters = glossaryItem.querySelectorAll(".block-letter");
                let blockDescs = glossaryItem.querySelectorAll(".block-desc");
                let blockQuotes = glossaryItem.querySelectorAll(".block-quote");
                let uls = glossaryItem.querySelectorAll("ul");

                let glossary = glossaryItem.closest(".glossary");
                if(glossary){
                  glossary.classList.add("no__padding");
                }

                if (searchValue?.length > 0) {
                    blockLetters.forEach(block => block.classList.add("hidden"));
                    blockDescs.forEach(block => block.classList.add("hidden"));
                    blockQuotes.forEach(block => block.classList.add("hidden"));
                    uls.forEach(block => block.classList.add("hidden"));

                    blockLetters.forEach(function (blockLetter) {
                        let blockLetterText = blockLetter.innerText.trim().toLowerCase();
                        if (blockLetterText?.includes(searchValue?.toLowerCase())) {
                            blockLetter.classList.remove("hidden");
                            matchFound = true;
                            let nextElement = blockLetter.nextElementSibling;
                            
                            while (nextElement && !nextElement.classList.contains("block-letter")) {
                                if ((nextElement.classList.contains("block-desc") || nextElement.classList.contains("block-quote") || nextElement.tagName?.toLowerCase() == "ul") && nextElement.classList.contains("hidden")) {
                                    nextElement.classList.remove("hidden"); // Show the hidden block-desc
                                }
                                nextElement = nextElement.nextElementSibling;
                            }
                          console.log("glossary", glossary)
                            if(glossary){
                              glossary.classList.remove("no__padding");
                            }
                        }
                    });
                  
                } else {
                    blockLetters.forEach(block => block.classList.remove("hidden"));
                    blockDescs.forEach(block => block.classList.remove("hidden"));
                    blockQuotes.forEach(block => block.classList.remove("hidden"));
                    uls.forEach(block => block.classList.remove("hidden"));
                    let glossarys = document.querySelectorAll(".glossary");
                    glossarys.forEach(function (element) {
                      if(element.classList.contains("no__padding")){
                        element.classList.remove("no__padding");
                      }
                    });
                }
            });

            let noResultFound = document.querySelectorAll(".no__result--found");
            if (!matchFound && searchValue?.length > 0) {
              noResultFound.forEach(function (element) {
                if(element.classList.contains("hidden")){
                  element.classList.remove("hidden");
                }
              });
            }else{
              noResultFound.forEach(function (element) {
                element.classList.add("hidden");
              });
            }
        });
        
      });
});

